import { httpClient } from 'api';
import { LinkedAccount } from 'types/LinkedAccount';

export const linkedAccountApi = {
	getLinkedAccounts: () => httpClient.get<LinkedAccount[]>('linked-account'),
	removeLinkedAccount: (id: number) => httpClient.delete<boolean>(`linked-account/${id}`),
	addMicrosoftAccount: (params?: Record<string, any>) =>
		httpClient.post<{ linkedAccount: LinkedAccount; redirectUrl: string }>(`linked-account/microsoft`, params),
	reauthMicrosoftAccount: (id: number, params?: Record<string, any>) =>
		httpClient.post<{ linkedAccount: LinkedAccount; redirectUrl: string }>(
			`linked-account/microsoft/${id}/reauth`,
			params
		),
	addMicrosoftAccountCalendar: (id: number, params?: Record<string, any>) =>
		httpClient.post<{ linkedAccount: LinkedAccount; redirectUrl: string }>(
			`linked-account/microsoft/${id}/calendar`,
			params
		),
	addGoogleAccount: (params?: Record<string, any>) =>
		httpClient.post<{ linkedAccount: LinkedAccount; redirectUrl: string }>(`linked-account/google`, params),
	reauthGoogleAccount: (id: number, params?: Record<string, any>) =>
		httpClient.post<{ linkedAccount: LinkedAccount; redirectUrl: string }>(
			`linked-account/google/${id}/reauth`,
			params
		),
	addGoogleAccountCalendar: (id: number, params?: Record<string, any>) =>
		httpClient.post<{ linkedAccount: LinkedAccount; redirectUrl: string }>(
			`linked-account/google/${id}/calendar`,
			params
		),
};
